/**
 * Aviso de focos indisponíveis FORA da aba Queimadas: sem ele, o mapa sem
 * focos (INPE fora do ar) parece "não há queimadas".
 */
import { useEffect } from 'react';
import { useFireStore } from '../fires/store';
import { refreshFires } from '../fires/useFireLayers';
import { dismissToast, showToast } from '../state/toasts';

type FireState = ReturnType<typeof useFireStore.getState>;

/** Alguma fonte de focos ligada está com erro? */
export function firesInError(s: Pick<FireState, 'sources' | 'status'>): boolean {
  return (Object.keys(s.sources) as (keyof FireState['sources'])[]).some((k) => s.sources[k] && s.status[k].state === 'error');
}

export function useFiresInError(): boolean {
  return useFireStore(firesInError);
}

/** Mostra (e retira) um aviso persistente quando os focos ficam indisponíveis. */
export function useFireErrorNotice(): void {
  useEffect(() => {
    let wasError = false;
    const check = () => {
      const err = firesInError(useFireStore.getState());
      if (err && !wasError) {
        showToast({
          id: 'fires-error',
          kind: 'warning',
          timeoutMs: 0,
          message: 'Focos de queimada indisponíveis: o INPE não respondeu. Vamos tentar de novo sozinhos.',
          action: { label: 'Tentar agora', onClick: () => refreshFires() },
        });
      } else if (!err && wasError) {
        dismissToast('fires-error');
      }
      wasError = err;
    };
    check();
    return useFireStore.subscribe(check);
  }, []);
}
